import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatsResolver } from './stats.resolver';
import { StatsComponent } from './stats.component';
import { AuthGuard } from '../auth/auth.guard';
import { ThemeResolver } from '../../theme/theme.resolver';

const routes: Routes = [
  {
    path: 'stats',
    component: StatsComponent,
    canActivate: [AuthGuard],
    data: { title: 'stats.title' },
    resolve: { data: StatsResolver, theme: ThemeResolver }
  },
  {
    path: 'stats/:id',
    component: StatsComponent,
    canActivate: [AuthGuard],
    data: { title: 'stats.title' },
    resolve: { data: StatsResolver, theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/stats/stats.routes.ts